<template>
  <v-container>
    <v-img
      data-cy="splash"
      class="image"
      :src="require('../../assets/mistake.png')"
    >
    </v-img>
    <div>
      <v-sheet class="text center-text mt-15 text-h5"
        >Sorry, something went wrong during payment.
      </v-sheet>
    </div>
    <div>
      <span class="center">
        <router-link data-cy="try_again" class="font-railway" :to="{ name: 'shopping-basket' }"
          >try again </router-link
        >
        <pre>|</pre>
        <router-link data-cy="web_shop" class="font-railway" :to="{ name: 'web-shop' }"
          > continue shopping </router-link
        >
        <pre>|</pre>
        <router-link data-cy="home" class="font-railway" :to="{ name: 'home' }"
          > home</router-link
        ></span
      >
    </div>
  </v-container>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {

  data() {
    return {}
  },

  methods: {
    ...mapMutations('payment', ['set']),
  },

  computed: {
    ...mapState('payment', {
        shoppingCart: (state) => state.shoppingCart
    })
  },

  created() {
    let localStorageCart = JSON.parse(localStorage.getItem('shoppingCart'))
    if (this.shoppingCart.length === 0 && localStorageCart.length > 0) {
      this.set(['shoppingCart', localStorageCart])
    }
  },
}
</script>

<style lang="css" scoped>
.image {
  margin-top: 75px;
  margin-inline: 40px;
  width: 50%;
  margin-inline: auto;
  border-radius: 10px;
}

.center-text {
  text-align: center;
}

.center {
  display: flex;
  justify-content: center;
}
</style>
